import { DataBean } from "../DataBean";

export class EmployeeFactors extends DataBean {



    public async importEmployeeFactors(filename: any, directory: any, dataStore: any, idEmployee: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_importEmployeeFactors_String_String_String_Number", [filename, directory, dataStore, idEmployee]);
    }

}
